import React from "react"
import { graphql, useStaticQuery } from "gatsby"
import BackgroundImage from "gatsby-background-image"
import { getImage } from "gatsby-plugin-image"
import { convertToBgImage } from "gbimage-bridge"
import Modal from "../modal/modal-offline-application"

import "./hero.css"

const HeroOffline = () => {
  // const { heroImage } = useStaticQuery(
  //   graphql`
  //     {
  //       heroImage: file(relativePath: { eq: "hero-offline.jpeg" }) {
  //         childImageSharp {
  //           gatsbyImageData(
  //             width: 1920
  //             layout: CONSTRAINED
  //             formats: [AUTO, WEBP, AVIF]
  //           )
  //         }
  //       }
  //     }
  //   `
  // )

  // const heroImageData = getImage(heroImage)

  // // Use like this:
  // const bgImage = convertToBgImage(heroImageData)

  return (
    <>
      <div
        // Tag="div"
        // {...bgImage}
        // fluid={imageData}
        className="hero-banner hero-home-offline-application"
        // preserveStackingContext
        style={{ backgroundPosition: "top center", height: "700px" }}
      >
        <div className="container">
          <div className="row">
            <div className="col-lg-6 col-md-6">
              <div className="hero-custom-quickbase">
                <h1 className="page-title font-weight-medium mt-0 mb-4">
                  Automate Construction Management Workflows Offline
                </h1>
                <p className="mb-0" style={{ paddingBottom: "20px" }}>
                  We build custom construction management solutions that work
                  offline, so you can stay on top of your projects. No matter
                  the job site. Don’t let WiFi access dictate your timelines.
                </p>
                <Modal />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default HeroOffline
